import axios from 'axios';

const API_URL = 'https://qwikbistro.shop';
const TOKEN = process.env.REACT_APP_QWIK_BISTRO_API_TOKEN;


const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Authorization': `Bearer ${TOKEN}`,
    'Content-Type': 'application/json',
  },
});

export const menuApiService = {
  // Get all products
  getAllProducts: async () => {
    try {
      const response = await axiosInstance.get('/menuItem/');
      return response.data.sort((a, b) => b.id - a.id); // Latest first
    } catch (error) {
      console.error('Error fetching products:', error);
      throw error;
    }
  },

  // Get single product
  getProduct: async (id) => {
    try {
      const response = await axiosInstance.get(`/menuItem/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching product:', error);
      throw error;
    }
  },

  // Update product
  updateProduct: async (id, productData) => {
    try {
      const response = await axiosInstance.put(`/menuItem/${id}`, productData);
      return response.data;
    } catch (error) {
      console.error('Error updating product:', error);
      throw error;
    }
  },

  // Delete product
  deleteProduct: async (id) => {
    try {
      await axiosInstance.delete(`/menuItem/${id}`);
      return true;
    } catch (error) {
      console.error('Error deleting product:', error);
      throw error;
    }
  },

  // Create new product
  createProduct: async (productData) => {
    try {
      const response = await axiosInstance.post('/menuItem/new', productData);
      return response.data;
    } catch (error) {
      console.error('Error creating product:', error);
      throw error;
    }
  },

  getAllCategories: async () => {
    try {
      const response = await axiosInstance.get('/menuItem/');

      return response.data.sort((a, b) => a.name.localeCompare(b.name));

    } catch (error) {
      console.error('Error fetching products:', error);
      throw error;
    }
  },

};